import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=230d91fd&scoped=true&"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d91fd",
  null
  
)

export default component.exports